import React from "react";
import { connect } from "react-redux";
import VendorContent from "containers/request/RequestContent/VendorContent";
import reqTypes from "dictionaries/ReqTypes";
import { batteryTabsACR, batteryTabsACRECO } from "helpers/RequestTabsHelper";
import {
  getChecklistInitialACR,
  getChecklistEcoACR,
} from "helpers/ChecklistBatteryHelper";

const RequestContentACR = ({ request, focusLab }) => {
  const checkListInitial = getChecklistInitialACR(request);
  const checkListECO = getChecklistEcoACR(request);

  switch (request.type) {
    case reqTypes.initial:
      return (
        <VendorContent
          tabs={batteryTabsACR}
          checkList={checkListInitial}
          defaultTab={focusLab ? "labInfo" : "deviceInfo"}
        />
      );
    case reqTypes.eco:
      return (
        <VendorContent
          tabs={batteryTabsACRECO}
          checkList={checkListECO}
          defaultTab={focusLab ? "labInfo" : "deviceInfo"}
        />
      );
    default:
      return null;
  }
};

function mapStateToProps({ request }) {
  return { request };
}

export default connect(mapStateToProps)(RequestContentACR);
